import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
export const toggleBuildCard = createAction(types.TOGGLE_BUILD_CARD);
